import React from 'react';
import Helmet from 'react-helmet';

import FieldTreeResultStore from '../services/fieldTreeResult/FieldTreeResultStore';
import FieldTreeResultContext from '../services/fieldTreeResult/FieldTreeResultContext';

import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { SearchForm } from '../components/searchmenus/FieldTreeResultSearch';
import { TableLayout } from '../components/tables/FieldTreeResultTable';

/**
 * 入場人数との差異画面
 */
export class FieldTreeResult extends React.Component {
  // 画面表示
  render() {
    return (
      <FieldTreeResultStore>
        <FieldTreeResultContext.Consumer>
          {({
            state,
            visibleFieldTreeResultList,
            infiniteScrollLoad,
            handleSearchParamsChange,
            handleFilterParamsChange,
            toggleTableRow,
            toggleAllItems,
          }) => (
            <React.Fragment>
              <div id='main' className='main'>
                <Helmet title={data.title} />
                <div className='main__header'>
                  <h1>{data.title}</h1>
                </div>

                <div id='infinityscroll-target' className='main__body'>
                  <div className='fieldtreeresult-content-wrapper'>
                    <SearchForm
                      fieldTreeResultData={state.fieldTreeResultData}
                      resultsTotal={state.resultsTotal}
                      searchParamsChanged={handleSearchParamsChange}
                      filterParamsChanged={handleFilterParamsChange}
                    />
                    <TableLayout
                      items={visibleFieldTreeResultList}
                      isOpenAllItems={state.isOpenAllItems}
                      toggleAllItems={toggleAllItems}
                      toggleTableRow={toggleTableRow}
                      displayIndividual={state.filterParams.displayIndividual}
                      displayTotal={state.filterParams.displayTotal}
                    />
                    <InfinityScrollLoad
                      targetId='infinityscroll-target'
                      total={state.resultsTotal}
                      callback={infiniteScrollLoad}
                      isLoading={state.isLoading}
                      ignoreIndicator={true}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </FieldTreeResultContext.Consumer>
      </FieldTreeResultStore>
    );
  }
}

// 定数
const data = {
  title: '作業実績 - 入場人数との差異',
};



// WEBPACK FOOTER //
// ./src/pages/FieldTreeResult.jsx